import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/SEOHead';
import LegalPageLayoutV2 from '@/components/marketing/legal/v2/LegalPageLayoutV2';

export default function Legal() {
  const { t } = useTranslation('marketing');

  return (
    <>
      <SEOHead
        title="Mentions légales — Velko POS"
        description="Mentions légales de Velko POS : éditeur (OpenInTech, Yaoundé), hébergement, propriété intellectuelle et contact légal."
        path="/mentions-legales"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Mentions légales', path: '/mentions-legales' },
        ]}
      />
      <LegalPageLayoutV2
        kind="legal"
        subtitle={t('legal.heroSubtitle')}
        lastUpdated={t('legal.lastUpdated')}
        content={t('legal.content')}
      />
    </>
  );
}
